import { useMemo } from "react";
import { useGetQueryData } from "@/utils/react-query-hooks/general";
import { extractAllBlocksFromTpl } from "@okf/ootils";

export const useAutoGenCollectionSubSpaces = ({ originalSubSpaces, content }) => {

  const { SELF_MANAGED_BASE_CONFIGS, deployment } = useGetQueryData("platformConfigs");
  const allTpls = useGetQueryData("allTpls");

  return useMemo(() => {
    const isEnabled = SELF_MANAGED_BASE_CONFIGS?.enable || deployment?._AutoGenCollectionPages?.enable;
    if (!isEnabled) return originalSubSpaces;

    const thisCollectionTagType = content?.meta?.kp_content_type;
    if (!thisCollectionTagType || !allTpls) return originalSubSpaces;

    // Keep FormBuilder and CustomCompInjector subSpaces from the original config
    const nonListingSubSpaces = originalSubSpaces.filter(
      (ss) => ss.builder !== "ListingBuilder"
    );

    // Find all templates that reference this collection's tag type
    const matchingTpls = allTpls.filter((tpl) => {
      // Exclude collections
      if (tpl.general?.segment === "collections") return false;

      try {
        const allBlocks = extractAllBlocksFromTpl({ tpl });
        return allBlocks.some(
          (block) =>
            block.valuePath?.startsWith("tags.") &&
            block.props?.tagType === thisCollectionTagType
        );
      } catch {
        return false;
      }
    });

    // Generate one ListingBuilder subSpace per matching template
    const autoGenListingSubSpaces = matchingTpls.map((tpl) => ({
      display: tpl.general?.content?.title,
      value: tpl.kp_content_type,
      builder: "ListingBuilder",
      configs: {
        contentTypes: [tpl.kp_content_type],
      },
    }));

    // Listing tabs first, then FormBuilder/other tabs at the end
    return [...autoGenListingSubSpaces, ...nonListingSubSpaces];
  }, [SELF_MANAGED_BASE_CONFIGS, deployment, allTpls, originalSubSpaces, content]);
};
